import React from "react";
import { useTranslation } from "react-i18next";

const ApiFailure = ({ refetch }: { refetch: VoidFunction }) => {
  const { t } = useTranslation();

  return (
    <div className="tw-flex-col tw-justify-center tw-items-center tw-gap-4 tw-inline-flex">
      <div className="tw-text-gray-700 tw-text-base tw-font-medium tw-font-['Lexend'] tw-leading-normal">
        {t("AlertsTypeConstant/ISKBKO003")}
      </div>

      <button
        className="tw-text-white tw-text-sm tw-font-normal tw-font-['Lexend'] tw-leading-tight tw-px-[15px] tw-py-[7px] tw-bg-primary tw-rounded-[17px] tw-shadow tw-justify-center tw-items-center tw-inline-flex tw-border-0"
        onClick={refetch}
      >
        {t("KbAssistantUploadFilesComponent/btn-03")}
      </button>
    </div>
  );
};

export default ApiFailure;
